/**
 * 회사 API
 *
 * 세금계산서 발급을 위한 고객 회사 정보 관리
 * 백엔드: olulo-mx-admin/app/Http/Controllers/Api/Customer/CompanyController.php
 */
import { apiClient } from './client';
import type {
  CompanyListResponse,
  CompanyResponse,
  CreateCompanyRequest,
} from './types';

export const companiesApi = {
  /**
   * 회사 목록 조회
   * GET /api/v1/users/me/companies
   */
  getCompanies: async (): Promise<CompanyListResponse> => {
    const response = await apiClient.get<CompanyListResponse>('/api/v1/users/me/companies');
    return response;
  },

  /**
   * 회사 상세 조회
   * GET /api/v1/users/me/companies/{id}
   */
  getCompany: async (id: number): Promise<CompanyResponse> => {
    const response = await apiClient.get<CompanyResponse>(`/api/v1/users/me/companies/${id}`);
    return response;
  },

  /**
   * 회사 생성
   * POST /api/v1/users/me/companies
   */
  createCompany: async (data: CreateCompanyRequest): Promise<CompanyResponse> => {
    const response = await apiClient.post<CompanyResponse>('/api/v1/users/me/companies', data);
    return response;
  },

  /**
   * 회사 수정
   * PUT /api/v1/users/me/companies/{id}
   */
  updateCompany: async (id: number, data: CreateCompanyRequest): Promise<CompanyResponse> => {
    const response = await apiClient.put<CompanyResponse>(`/api/v1/users/me/companies/${id}`, data);
    return response;
  },

  /**
   * 회사 삭제
   * DELETE /api/v1/users/me/companies/{id}
   */
  deleteCompany: async (id: number): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.delete<{ success: boolean; message: string }>(
      `/api/v1/users/me/companies/${id}`
    );
    return response;
  },

  /**
   * 기본 회사 설정
   * POST /api/v1/users/me/companies/{id}/default
   */
  setDefaultCompany: async (id: number): Promise<CompanyResponse> => {
    const response = await apiClient.post<CompanyResponse>(
      `/api/v1/users/me/companies/${id}/default`,
      {}
    );
    return response;
  },
};
